import { Button } from "@components/ui/button";
import Logo from "@components/ui/logo";
import { SidebarHeader } from "@components/ui/sidebar";
import { EditIcon } from "lucide-react";
import { generatePath, Link } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { Trans } from "@lingui/react/macro";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@components/ui/tooltip";
import AccessControl from "@components/AccessControl";

export function HeaderNav({ orgUuid }: { orgUuid: string }) {
  return (
    <SidebarHeader>
      <div className="flex items-center justify-between">
        <Logo className="w-fit" />

        <AccessControl>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                id="create-new-alert-button"
                variant="outline"
                size="icon"
                asChild
              >
                <Link to={generatePath(ROUTES.MENTION_NEW_ORGID, { orgUuid })}>
                  <EditIcon />
                </Link>
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <Trans>Skapa Bevakning</Trans>
            </TooltipContent>
          </Tooltip>
        </AccessControl>
      </div>
    </SidebarHeader>
  );
}
